import { AppThunk } from "../../store";
import { ResetSocial, SetSocial } from "./slice";

export const setSocialDetails =
  (Data: any): AppThunk =>
  async (dispatch) => {
    if (Data.type === "login") dispatch(SetSocial(Data));
    else dispatch(ResetSocial());
  };
